export default !!(typeof process !== 'undefined' && process.versions && process.versions.node);
